// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2980":"9cb0a77b","6945":"4289473b","9675":"52c3caad"}[chunkId] + ".css";
};